const swapElements = (array, index1, index2) => {
  const result = [...array];

  let temp = array[index1];
  result[index1] = array[index2];
  result[index2] = temp;

  return result;
};

const getAverageValue = (array) => {
  return parseFloat((array.reduce((a, b) => a + b, 0) / array.length).toFixed(2));
};

const includesAll = (target, array) => {
  return target.every((el) => array.includes(el));
};

const includesSome = (target, array) => {
  const contains = array.some((element) => {
    return target.includes(element);
  });

  return contains;
};

const arrayEquals = (array1, array2) => {
  return includesAll(array1, array2) && includesAll(array2, array1);
};

const findDuplicatedValues = (array) => {
  const duplicatedValues = array.filter((item, index) => array.indexOf(item) !== index);
  const uniqueDuplicatedValues = [...new Set(duplicatedValues)];

  return uniqueDuplicatedValues;
};

const sortByKey = (array, key, desc = false) => {
  return array.sort((a, b) => {
    const keyA = a[key];
    const keyB = b[key];
    if (keyA < keyB) return desc ? 1 : -1;
    if (keyA > keyB) return desc ? -1 : 1;
    return 0;
  });
};

const getCommonValues = (array1, array2) => {
  const commonValues = array1.filter((value) => array2.includes(value));

  return commonValues;
};

const arrayUtil = {
  swapElements,
  getAverageValue,
  includesAll,
  includesSome,
  arrayEquals,
  findDuplicatedValues,
  sortByKey,
  getCommonValues
};

export default arrayUtil;
